module.exports = __webpack_public_path__ + "images/erp-nation-glad-title.1792157180594.png";